import styled from 'styled-components';
import ArticleCard from './ArticleCard';
import React from 'react';

const Container = styled.div`
  margin-left: auto;
  position: relative;
  height: auto;
  margin-top: 0em;
`;

const Grid = styled.div`
  display: grid;
  row-gap: 12em; /* Consistent gap between cards */
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  padding: 2em;
`;

export default function MobileGrid({ articles }) {

  return (
    <Container>
      <Grid>
        {articles.map((item, index) => (
          <ArticleCard
            key={item.article_url}
            article_title={item.article_title}
            article_url={item.article_url}
            article_byline={item.article_byline}
            article_image={item.article_image}
            ten={index === 10 ? "true" : "false"}
          />
        ))}
      </Grid>
    </Container>
  );
}
